// extracted by mini-css-extract-plugin
module.exports = {"container":"IdentificationTagTab_container__1Lsfx"};